// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"2a93f1fa7bf3cce5","md-light-indigo":"67ffec185130261a","md-dark-indigo":"b37c1d6693c021d0"}[chunkId] + ".css";
};